import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "OnPageNavigation",
    component: () => (__SERVER__ ? require("./on-page-navigation-view") : import("./on-page-navigation-view"))
});

export default definition;
